module.exports = __webpack_public_path__ + "static/media/Week 1 Sunday Dessert.2a8aa9aa.png";